import { UserRoleDto } from '@/api/generated';

export const isAuthorized = (
  authorizedRoles: UserRoleDto | UserRoleDto[],
  currentUserRole: UserRoleDto | undefined,
): boolean => {
  if (!currentUserRole) {
    return false;
  }
  if (Array.isArray(authorizedRoles) && authorizedRoles.length) {
    return authorizedRoles.includes(currentUserRole);
  }
  if (typeof authorizedRoles === 'string' && authorizedRoles.length) {
    return currentUserRole === authorizedRoles;
  }
  return true;
};
